import React from 'react'
import { useTranslation } from 'next-i18next'

import { useIsMobile } from '@/utils/useMobile'
import { getNavigationIcon } from '@/constants/navigationAssets'

import { usePopupTracking } from '@/hooks/usePopupTracking'

import { useMarket } from '@/utils/multi-markets/context'

import Button from '../Button/Button'

import {
  PopupWrapperBottom,
  PopupContentBottom,
  PopupImageBottom,
  PopupSecondaryText,
  PopupBottomImageTextCnt,
  ButtonMobileWrapper,
  CloseIconPopupBottom,
  PopupMainBottomText,
  PopupBottomText,
  PopupWrapperOverlay,
  PopupPromoBox
} from './Popup.styled'

interface PopupBottomProps {
  mainText: string
  secondaryTextOnImage: string
  image: string
  onClose: () => void
  onDiscover: () => void
}

const PopupBottom: React.FC<PopupBottomProps> = ({
  mainText,
  secondaryTextOnImage,
  image,
  onClose,
  onDiscover
}) => {
  const { isMobile } = useIsMobile()
  const { t } = useTranslation('popups')
  const { trackClose, trackConfirm } = usePopupTracking(
    'POPUP_BOTTOM_SEARCHLIST'
  )
  const { market } = useMarket()

  const isEidPopupAvailable =
    market === 'ae' && new Date() < new Date('2025-04-07')

  const handleClose = () => {
    trackClose()
    onClose()
  }

  const handleDiscover = () => {
    trackConfirm()
    onDiscover()
  }

  const content = (
    <PopupWrapperBottom data-test-id="popup-wrapper">
      <CloseIconPopupBottom
        onClick={handleClose}
        data-test-id="popup-close-button"
      >
        <img
          src={
            isMobile
              ? getNavigationIcon('close')
              : getNavigationIcon('closeWhite')
          }
          alt="close-popup"
          width={18}
          height={18}
        />
      </CloseIconPopupBottom>
      <PopupContentBottom>
        <PopupBottomImageTextCnt>
          <PopupImageBottom src={image} alt="Popup" />
          <PopupBottomText>
            <PopupMainBottomText
              dangerouslySetInnerHTML={{ __html: mainText }}
            />
            <PopupSecondaryText
              short={isEidPopupAvailable}
              dangerouslySetInnerHTML={{ __html: secondaryTextOnImage }}
            />
            {isEidPopupAvailable && (
              <PopupPromoBox short={isEidPopupAvailable}>
                {t('popup.text.eidPromo')}
              </PopupPromoBox>
            )}
          </PopupBottomText>
        </PopupBottomImageTextCnt>
        <ButtonMobileWrapper>
          <Button
            label={t(
              isEidPopupAvailable
                ? 'popup.button.discoverPackages'
                : 'popup.button.discover'
            )}
            onClick={handleDiscover}
            buttonType="discover"
            data-test-id="popup-confirm-button"
          />
        </ButtonMobileWrapper>
      </PopupContentBottom>
    </PopupWrapperBottom>
  )

  return isMobile ? (
    <PopupWrapperOverlay>{content}</PopupWrapperOverlay>
  ) : (
    content
  )
}

export default PopupBottom
